import { useEffect, useState } from "react";
import axiosInstance from "../../Axois/Axois";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import Header from "../../GlobalComponent/Header/Header";
import DonationModal from "./Donationmodal";

const SectionFour = () => {
  const [borrowers, setBorrowers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [fundInputs, setFundInputs] = useState({});
  const [borrowerOptions, setBorrowerOptions] = useState([]);
  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czechia",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine State",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "UK",
    "US",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    city: "",
    country: "",
    payment_method: "stripe",
    total: "",
  });

  const location = useLocation();
  const navigate = useNavigate();
  const isProfilePage = location.pathname === "/entrepreneurprofile";
  const token = localStorage.getItem("useToken");
  const [donationDetails, setDonationDetails] = useState({
    borrower_id: "",
    loan: "",
  });
  useEffect(() => {
    const fetchBorrowers = async () => {
      try {
        const response = await axiosInstance.get("/all/borrower");
        setBorrowers(response?.data?.data || []);
        const allBorrowers = response?.data?.data || [];
        const filtered = allBorrowers.map((b) => ({
          id: b.id,
          name: b.name,
          loan: b.loan,
        }));
        setBorrowerOptions(filtered);
      } catch (error) {
        console.error("Error fetching borrowers:", error);
      }
    };
    fetchBorrowers();
  }, []);

  const visibleBorrowers = isProfilePage ? borrowers : borrowers.slice(0, 4);

  const handleFundClick = (borrower) => {
    const userData = localStorage.getItem("user");
    let userFields = {};

    if (userData) {
      const user = JSON.parse(userData);
      userFields = {
        name: user.name || "",
        email: user.email || "",
        contact: user.phone || "",
      };
    }

    setDonationDetails({
      borrower_id: borrower.id,
      loan: borrower.loan || "",
    });

    setFormData({
      ...userFields,
      city: "",
      country: "",
      total: fundInputs[borrower.id] || "", // yahan se value aa rahi hai
      payment_method: "stripe",
    });

    setShowModal(true);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setFormData((prev) => ({
        ...prev,
        name: user.name || "",
        email: user.email || "",
        contact: user.phone || "",
        // city: prev.city, // keep previous city
        // country: prev.country, // keep previous country
        // total: prev.total, // keep previous total (do not reset!)
      }));
    }
  }, [showModal]);

  const handleFormChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append("name", formData.name);
    payload.append("email", formData.email);
    payload.append("contact", formData.contact);
    payload.append("city", formData.city);
    payload.append("country", formData.country);
    payload.append("payment_method", formData.payment_method || "stripe");
    payload.append("total", formData.total);
    payload.append("borrower_id", donationDetails.borrower_id);

    // payload.append('borrowers[0][loan]', donationDetails.loan);

    try {
      const response = await axiosInstance.post("/payment", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const url = response?.data?.data;
      console.log(url, "url");

      if (url) {
        window.location.href = url;
      } else {
        toast.success("No payment URL returned.");
      }
    } catch (error) {
      console.error("Payment error:", error);

      const errorMessage = error?.message;

      if (errorMessage === "Unauthenticated.") {
        toast.error("Please login first.");
        setTimeout(() => {
          navigate("/login");
        }, 4000); // 2 second delay for toast to appear
      } else {
        toast.error(errorMessage || "Something went wrong.");
      }
    }
  };
  // const truncateText = (text, wordLimit) => {
  //   if (!text) return "";
  //   const words = text.split(" ");
  //   if (words.length <= wordLimit) return text;
  //   return words.slice(0, wordLimit).join(" ") + " ...";
  // };

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div className="entrepreneur-profile-section py-5">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h2 className="profile-section-title">
                Entrepreneur{" "}
                <span className="profile-highlight">Profile's</span>
              </h2>
            </div>
          </div>

          <div className="row justify-content-center">
            {visibleBorrowers.map((entrepreneur) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center mb-4">
                <div className="profile-card">
                  <div className="profile-image-container">
                    <img
                      src={
                        entrepreneur.image?.trim() ||
                        "https://thumbs.dreamstime.com/b/default-avatar-profile-vector-user-profile-default-avatar-profile-vector-user-profile-profile-179376714.jpg"
                      }
                      alt={entrepreneur.name}
                      className="profile-img"
                    />
                  </div>

                  <h5 className="profile-name">{entrepreneur.name}</h5>

                  <div className="note-box">
                    <p>{entrepreneur.note}</p>
                  </div>

                  <div className="d-flex justify-content-between align-items-center px-3 mb-3">
                    <Link
                      to={`/profile1/${entrepreneur.id}`}
                      className="text-primary fw-semibold text-decoration-none"
                    >
                      View Profile
                    </Link>
                    <div className="goal-text mb-0">
                      ${entrepreneur.loan} Goal
                    </div>
                  </div>

                  <div className="fund-input-group">
                    <div className="input-with-dollar">
                      <span>$</span>
                      <input
                        type="number"
                        className="fund-input"
                        placeholder="Enter Amount"
                        value={fundInputs[entrepreneur.id] || ""}
                        onChange={(e) =>
                          setFundInputs((prev) => ({
                            ...prev,
                            [entrepreneur.id]: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <button
                      className="fund-btn"
                      onClick={() => handleFundClick(entrepreneur)}
                    >
                      Fund Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {!isProfilePage && borrowers.length > 4 && (
            <div className="row mt-3">
              <div className="col-12 text-center">
                <button
                  className="btn btn-outline-warning"
                  onClick={() => navigate("/entrepreneurprofile")}
                >
                  View More
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Form onSubmit={handlePaymentSubmit}>
            {/* Header */}
            <Modal.Header
              closeButton
              style={{ backgroundColor: "#e65c00" }}
              className="  text-white"
            >
              <Modal.Title className="fw-bold">
                💖 Complete Your Donation
              </Modal.Title>
            </Modal.Header>

            {/* Body */}
            <Modal.Body className="bg-light text-dark px-4 py-3">
              <Form.Group controlId="formName" className="mb-3">
                <Form.Label className="fw-semibold">Full Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  className="border-dark shadow-sm text-dark "
                  value={formData.name}
                  onChange={handleFormChange}
                />
              </Form.Group>

              <Form.Group controlId="formEmail" className="mb-3">
                <Form.Label className="fw-semibold">Email</Form.Label>
                <Form.Control
                  required
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  className="border-dark shadow-sm text-dark"
                  value={formData.email}
                  onChange={handleFormChange}
                />
              </Form.Group>

              <Form.Group controlId="formContact" className="mb-3">
                <Form.Label className="fw-semibold">Contact Number</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="contact"
                  placeholder="03XX-XXXXXXX"
                  className="border-dark shadow-sm text-dark"
                  value={formData.contact}
                  onChange={handleFormChange}
                />
              </Form.Group>

              <Form.Group controlId="formAmount" className="mb-3">
                <Form.Label className="fw-semibold">Donation Amount</Form.Label>
                <Form.Control
                  required
                  type="number"
                  name="total"
                  placeholder="Enter amount "
                  className="border-dark shadow-sm text-dark"
                  value={formData.total || ""}
                  onChange={handleFormChange}
                />
              </Form.Group>

              <Form.Group controlId="formCity" className="mb-3">
                <Form.Label className="fw-semibold">City</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="city"
                  placeholder="e.g., Lahore"
                  className="border-dark shadow-sm text-dark"
                  value={formData.city}
                  onChange={handleFormChange}
                />
              </Form.Group>

              <Form.Group controlId="formCountry" className="mb-2">
                <Form.Label className="fw-semibold">Country</Form.Label>
                <Form.Select
                  name="country"
                  required
                  className="border-dark shadow-sm text-dark"
                  value={formData.country}
                  onChange={handleFormChange}
                >
                  <option value="">-- Select Country --</option>
                  {countries.map((country, index) => (
                    <option key={index} value={country}>
                      {country}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Modal.Body>

            {/* Footer */}
            <Modal.Footer className="bg-light px-4 py-3">
              <Button
                variant="outline-secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </Button>
              <Button type="submit" variant="success" className="fw-bold">
                🚀 Proceed to Pay
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>

      <DonationModal borrowers={borrowerOptions} />
      <Header borrowers={borrowerOptions} />
    </>
  );
};

export default SectionFour;
